export default class ValidationItem {
    private readonly message: string;
    private readonly value: unknown;

    constructor(message: string, value: unknown) {
        this.message = message;
        this.value = value;
    }
}
